var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 903,
    viewBox: "0 0 311 903",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.587 901.999C234.543 821.886 223.213 805.137 179.402 727.544C168.667 708.535 152.662 672.254 138.676 628.245C134.483 615.075 130.825 602.083 127.59 589.326C104.553 498.043 113.052 400.546 134.472 306.067C189.136 65.007 87.6664 -173.506 -103.347 -265.459C-294.689 -357.562 -531.772 -282.686 -663.212 -132.713C-680.314 -113.199 -756.668 -20.5104 -781.316 89.3953C-859.237 436.393 -538.67 623.897 -36.0139 801.968C-26.2347 805.424 20.595 819.936 30.5678 822.755L309.616 902.038L309.587 901.999Z",
    stroke: "black",
    strokeOpacity: 0.49,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape2.f4f820dd3b08258d218871d4c12f5e54.svg";
export { ForwardRef as ReactComponent };